// Module
var code = `<div class="hero__layout">
  <div class="hero__content">
    <a class="hero__ribbon" href="{{attrRibbonHref}}">{{ribbonText}}</a>
    <span class="hero__eyebrow">{{eyebrow}}</span>
    <h1 class="hero__headline">{{headline}}</h1>
    <div class="hero__subheadline">{{subheadline}}</div>
    <a class="btn btn-primary px-8 hero__cta" href="{{attrCtaHref}}">
      {{ctaText}}
    </a>
  </div>
  <div class="hero__image">
    <img src="{{attrImageSrc}}" alt="{{attrImageAlt}}" />
  </div>
</div>
`;
// Exports
module.exports = code;